import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
export const ListServiceAccountGroupsResponseSchema = z.object({
    items: z.array(z.object({
        id: z.string(),
        name: z.string(),
    })),
});
export class ListServiceAccountGroupsResponseDto extends createZodDto(ListServiceAccountGroupsResponseSchema) {
}
